import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import Button from "react-bootstrap/Button";


import FldCloseIcon from "../images/round-close-icon.svg";

import ValidationAlertIcon from "../images/validation-alert-icon.svg";
import SparkleBigIcon from "../images/sparkle-big-icon.svg";
import HouseMobIcon from "../images/house-mob-icon.svg";
import NotifMobIcon from "../images/notif-mob-icon.svg";
import ClientbookMobIcon from "../images/clientbook-mob-icon.svg";
import UserMobIcon from "../images/user-mob-icon.svg";
import LetsGetMoboffcanvas from "../components/LetsGetMoboffcanvas";


const GitchaPremiumUpgrade = () => {

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  return (
    <>
    <div className="mobile-wrapper bg-upgrade header-adj h-100">

      <div className="mobile-wrapper-inner bg-grey-transparent pad-top-38 position-relative middle-content">
      <div className=" position-relative">
      <Button variant="" className="btn round-back-btn"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.41678 4.49971C8.66086 4.74379 8.66086 5.13951 8.41678 5.38359L4.42539 9.37498H17.0832C17.4283 9.37498 17.7082 9.65481 17.7082 9.99998C17.7082 10.3452 17.4283 10.625 17.0832 10.625H4.42539L8.41678 14.6164C8.66086 14.8605 8.66086 15.2562 8.41678 15.5003C8.1727 15.7443 7.77697 15.7443 7.5329 15.5003L2.47456 10.4419C2.35735 10.3247 2.2915 10.1657 2.2915 9.99998C2.2915 9.83422 2.35735 9.67525 2.47456 9.55804L7.5329 4.49971C7.77697 4.25563 8.1727 4.25563 8.41678 4.49971Z" fill="#1B1C1E"/>
</svg>
</Button>
      </div>
      <div className="premium-info-mobwrap clearfix">
        
        
          <h2>Gitcha <span>Premium</span> <img className="align-text-baseline mb-1" src={SparkleBigIcon} /></h2>

          <p>Enhance your professional presence and close more deals with exclusive tools and features</p>
         <ul className="pb-20">
          <li>
            <div className="premium-info-icn"><img src={UserMobIcon} /></div>
            <div className="premium-info-text">Custom agent profile and Premium badge</div>
          </li>
          <li>
            <div className="premium-info-icn"><img src={HouseMobIcon} /></div>
            <div className="premium-info-text">Unlimited properties in your inventory</div>
          </li>
          <li>
            <div className="premium-info-icn"><img src={NotifMobIcon} /></div>
            <div className="premium-info-text">10 free introductions per month</div>
          </li>
          <li>
            <div className="premium-info-icn"><img src={ClientbookMobIcon} /></div>
            <div className="premium-info-text">Pro dashboard with client management tools </div>
          </li>

          </ul>

          <div className="btn-wrap text-center pb-4">
                          <button type="button" class="btn btn-primary w-100 mb-4"  onClick={handleShow}>Upgrade Today</button>
                         
                          <a href="#" class="blue-text-link">Skip for now</a>
                  
                        </div>

          
      </div>


        

        

        

        

        
        
        
        
        
                       
      
      </div>
      <div className="foot-note">By tapping the button, I agree to the Terms and Conditions and authorize an annual charge of <span>Lorem ipsum dolor sit amet consectetur. Mi integer ultrices viverra augue eu porttitor enim.</span></div>
      
    </div>
    <LetsGetMoboffcanvas
         
    show={show}
 onHide={handleClose}
 />
 </>
  );
};

export default GitchaPremiumUpgrade;
